<template>
<div class="container-fluid">
	<div class="row justify-content-center">
		<div class="col-sm-6 col-md-4 col-lg-3">
			<h1>Pagina niet gevonden</h1>
			<p>
				De pagina die u zoekt kon niet worden gevonden.
			</p>
		</div>
	</div>
</div>
</template>
<script>
export default {
	name: 'NotFound'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// 404.vue?4e6b6365